import { OrderSummaryDataType } from "@redotech/redo-model/advanced-flow/type-system/data-types/trackable-types";
import {
  Alignment,
  CartLayoutType,
  FontFamily,
  SharedProps,
  Size,
} from "@redotech/redo-model/email-builder";
import { memo } from "react";
import { EmailLineItem } from "./email-line-item";
import { OrderTableHeader } from "./order-summary";

export type FulfillmentSummaryState = {
  padding: number;
  sectionColor: string;
  textColor: string;
  fontFamily: FontFamily;
  imageSize: Size;
  imageCornerRadius: number;
  schemaFieldName?: string;
} & SharedProps;

export const EmailFulfillmentSummary = memo(function fulfillmentSummary(
  props: FulfillmentSummaryState,
) {
  if (!props.schemaFieldName) throw new Error("schemaFieldName is required");
  const fulfillmentSummary = props.schemaInstance[
    props.schemaFieldName
  ] as OrderSummaryDataType["Trackable Summary"];

  //We will also hide items with the "intangible" product tag
  const otherExceptRedo = fulfillmentSummary.otherLineItems.filter(
    (li) => !li.isRedo && !li.tags.includes("intangible"),
  );

  return (
    <div
      style={{
        backgroundColor: props.sectionColor,
        color: props.textColor,
        fontFamily: props.fontFamily,
      }}
    >
      <OrderTableHeader title="Items in this shipment:" />
      {fulfillmentSummary.relevantLineItems
        .filter((li) => !li.isRedo)
        .map((item, index) => (
          <EmailLineItem
            alignment={Alignment.LEFT}
            format={props.format}
            imageCornerRadius={props.imageCornerRadius}
            imageSize={props.imageSize}
            isBuilder={props.isBuilder}
            isLastInRow={
              index === fulfillmentSummary.relevantLineItems.length - 1
            }
            item={item}
            key={index}
            showDummyImages={props.isBuilder}
            showImage
            showPrice
            showQuantity
            showTitle
            showVariant
            stackType={CartLayoutType.ROWS}
            team={props.team}
            textColor={props.textColor}
            utm={props.utm}
          />
        ))}

      {otherExceptRedo.length > 0 && (
        <>
          <hr style={{ marginTop: "16px", marginBottom: "16px" }} />
          <OrderTableHeader
            title={`Other items in this ${fulfillmentSummary.trackableType.lowerCase}:`}
          />
          {otherExceptRedo.map((item, index) => (
            <EmailLineItem
              alignment={Alignment.LEFT}
              format={props.format}
              imageCornerRadius={props.imageCornerRadius}
              imageSize={props.imageSize}
              isBuilder={props.isBuilder}
              isLastInRow={index === otherExceptRedo.length - 1}
              item={item}
              key={index}
              showImage
              showPrice
              showQuantity
              showTitle
              showVariant
              stackType={CartLayoutType.ROWS}
              team={props.team}
              textColor={props.textColor}
              utm={props.utm}
            />
          ))}
        </>
      )}
    </div>
  );
});
